export default __webpack_public_path__ + "resources/docs/7_busines_navigating_business_credit_compressed.a610cc56.pdf";